import * as React from "react"
import {Grid} from "@mui/material";
import MatchersSKUsDrawerCategory from "./Category";
import MatchersSKUsDrawerBrand from "./Brand";
import MatchersSKUsDrawerCompany from "./Company";
import MatchersSKUsDrawerCustomer from "./Customer";
import MatchersSKUsDrawerLine from "./Line";
import MatchersSKUsDrawerSkuName from "./SkuName";
import MatchersSKUsDrawerEan from "./Ean";
import MatchersSKUsDrawerGender from "./Gender";
import MatchersSKUsDrawerSize from "./Size";
import MatchersSKUsDrawerUnitySize from "./UnitySize";
import MatchersSKUsDrawerAvailable from "./Available";
import MatchersSKUsDrawerImageURL from "./ImageURL";
import MatchersSKUsDrawerImage from "./Image";


export default function MatchersSKUsDrawerContent() {

    return <Grid container spacing={2}>
		<Grid item xs={0} md={9} />

		<Grid item xs={12} md={3}>
            <MatchersSKUsDrawerCustomer />
        </Grid>

        <Grid item xs={12} md={9}>
            <MatchersSKUsDrawerCategory />
        </Grid>

        <Grid item xs={12} md={3}>
            <MatchersSKUsDrawerCompany />
        </Grid>

        <Grid item xs={12} md={6}>
			<MatchersSKUsDrawerBrand />
		</Grid>

        <Grid item xs={12} md={6}>
			<MatchersSKUsDrawerLine />
		</Grid>

		<Grid item xs={12}>
			<MatchersSKUsDrawerSkuName />
		</Grid>

		<Grid item xs={6}>
			<MatchersSKUsDrawerEan />
		</Grid>

		<Grid item xs={3}>
			<MatchersSKUsDrawerSize />
		</Grid>

		<Grid item xs={3}>
			<MatchersSKUsDrawerUnitySize />
		</Grid>

		<Grid item xs={4}>
			<MatchersSKUsDrawerGender />
		</Grid>

		<Grid item xs={2}>
            <MatchersSKUsDrawerAvailable
                label="Pricing"
                type="availablePricing"
            />
        </Grid>

        <Grid item xs={3}>
            <MatchersSKUsDrawerAvailable
                label="Marketplaces"
                type="availableMarketplaces"
            />
        </Grid>

        <Grid item xs={3}>
            <MatchersSKUsDrawerAvailable
                label="Monitoring"
                type="availableMonitoring"
            />
        </Grid>

		<Grid item xs={4}>
			<MatchersSKUsDrawerImage />
		</Grid>

		<Grid item xs={8}>
			<MatchersSKUsDrawerImageURL />
		</Grid>
    </Grid>
}